/* SUNVOLT – Jämför produkter. localStorage-lista + flytande rad + drawer med spec-tabell.
   Hämtar varje produkts kolumn via /products/{handle}?view=compare och matchar specar per etikett. */
(function () {
  'use strict';
  var KEY = 'sv-compare';
  var cfg = { heading: 'Jämför produkter', max: 4, labels: '' };
  try {
    var cEl = document.querySelector('[data-sv-cmp-config]');
    if (cEl) { var p = JSON.parse(cEl.textContent); for (var k in p) cfg[k] = p[k]; }
  } catch (e) {}
  var MAX = parseInt(cfg.max, 10) || 4;
  var CONFIG_LABELS = (cfg.labels || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);

  function norm(s) { return (s || '').trim().toLowerCase(); }
  function getList() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} syncToggles(); renderBar(); }
  function has(h) { return getList().indexOf(h) !== -1; }
  function add(h) { var l = getList(); if (l.indexOf(h) !== -1) return; if (l.length >= MAX) { flashBar(); return; } l.push(h); save(l); }
  function remove(h) {
    var l = getList().filter(function (x) { return x !== h; });
    save(l);
    if (isOpen()) { if (l.length) buildTable(); else closeDrawer(); }
  }
  function clear() { save([]); closeDrawer(); }

  /* ---- kort-toggles ---- */
  function syncToggles() {
    var l = getList();
    document.querySelectorAll('[data-sv-cmp-toggle]').forEach(function (btn) {
      var on = l.indexOf(btn.getAttribute('data-sv-cmp-toggle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-sv-cmp-toggle]');
    if (toggle) { e.preventDefault(); var h = toggle.getAttribute('data-sv-cmp-toggle'); if (has(h)) remove(h); else add(h); return; }
    if (e.target.closest('[data-sv-cmp-open]')) { openDrawer(); return; }
    if (e.target.closest('[data-sv-cmp-clear]')) { clear(); return; }
    if (e.target.closest('[data-sv-cmp-close]') || e.target.closest('[data-sv-cmp-overlay]')) { closeDrawer(); return; }
    var rm = e.target.closest('[data-sv-cmp-remove]');
    if (rm) { remove(rm.getAttribute('data-sv-cmp-remove')); }
  });

  /* ---- flytande rad ---- */
  var bar = document.querySelector('[data-sv-cmp-bar]');
  function renderBar() {
    if (!bar) return;
    var l = getList();
    var c = bar.querySelector('[data-sv-cmp-count]');
    if (c) c.textContent = l.length;
    bar.hidden = l.length === 0;
    document.documentElement.classList.toggle('sv-cmp-has', l.length > 0);
  }
  function flashBar() { if (bar) { bar.classList.add('sv-cmp__bar--max'); setTimeout(function () { bar.classList.remove('sv-cmp__bar--max'); }, 700); } }

  /* ---- drawer ---- */
  var root = document.querySelector('[data-sv-compare]');
  var drawer = document.querySelector('[data-sv-cmp-drawer]');
  var overlay = document.querySelector('[data-sv-cmp-overlay]');
  var tableEl = document.querySelector('[data-sv-cmp-table]');
  var loadingEl = document.querySelector('[data-sv-cmp-loading]');
  var emptyEl = document.querySelector('[data-sv-cmp-empty]');
  function isOpen() { return drawer && !drawer.hidden; }
  var lastTrigger = null;
  function openDrawer() {
    if (!drawer) return;
    lastTrigger = document.activeElement;
    overlay.hidden = false; drawer.hidden = false;
    document.body.classList.add('sv-cmp-open');
    requestAnimationFrame(function () { if (root) root.classList.add('sv-cmp--open'); });
    // Fånga fokus i drawern (återanvänder Dawns globala trapFocus)
    if (typeof trapFocus === 'function') trapFocus(drawer, drawer.querySelector('[data-sv-cmp-close]'));
    else drawer.focus();
    buildTable();
  }
  function closeDrawer() {
    if (!drawer) return;
    if (root) root.classList.remove('sv-cmp--open');
    document.body.classList.remove('sv-cmp-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(lastTrigger); // återställer fokus till knappen
    else if (lastTrigger) lastTrigger.focus();
    setTimeout(function () { drawer.hidden = true; overlay.hidden = true; }, 280);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) closeDrawer(); });

  function fetchCol(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=compare', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { var d = document.createElement('div'); d.innerHTML = html; return d.querySelector('.sv-cmp-col'); })
      .catch(function () { return null; });
  }

  function buildTable() {
    if (!tableEl) return;
    var l = getList();
    if (!l.length) { if (emptyEl) emptyEl.hidden = false; tableEl.innerHTML = ''; return; }
    if (emptyEl) emptyEl.hidden = true;
    if (loadingEl) loadingEl.hidden = false;
    Promise.all(l.map(fetchCol)).then(function (cols) {
      if (loadingEl) loadingEl.hidden = true;
      cols = cols.filter(Boolean);
      if (!cols.length) { if (emptyEl) emptyEl.hidden = false; tableEl.innerHTML = ''; return; }

      var maps = cols.map(function (c) {
        var m = {};
        c.querySelectorAll('.sv-cmp-spec[data-label]').forEach(function (s) { m[norm(s.getAttribute('data-label'))] = s.textContent.trim(); });
        return m;
      });
      var defs = [];
      if (CONFIG_LABELS.length) {
        defs = CONFIG_LABELS.map(function (lab) { return { display: lab, key: norm(lab) }; });
      } else {
        var seen = {};
        cols.forEach(function (c) {
          c.querySelectorAll('.sv-cmp-spec[data-label]').forEach(function (s) {
            var key = norm(s.getAttribute('data-label'));
            if (!seen[key]) { seen[key] = 1; defs.push({ display: s.getAttribute('data-label'), key: key }); }
          });
        });
      }

      var t = document.createElement('table');
      t.className = 'sv-cmp__t';
      var thead = document.createElement('thead');
      var hr = document.createElement('tr');
      hr.appendChild(document.createElement('td'));
      cols.forEach(function (c) {
        var th = document.createElement('th'); th.scope = 'col'; th.className = 'sv-cmp__th-prod';
        var head = c.querySelector('.sv-cmp-col__head');
        if (head) th.appendChild(head.cloneNode(true));
        hr.appendChild(th);
      });
      thead.appendChild(hr); t.appendChild(thead);

      var tbody = document.createElement('tbody');
      defs.forEach(function (def) {
        if (!maps.some(function (m) { return m[def.key]; })) return; // dölj rader där ingen produkt har värde
        var tr = document.createElement('tr');
        var rh = document.createElement('th'); rh.scope = 'row'; rh.textContent = def.display;
        tr.appendChild(rh);
        maps.forEach(function (m) {
          var td = document.createElement('td');
          var v = m[def.key];
          if (v) td.textContent = v; else td.innerHTML = '<span class="sv-cmp__dash" aria-label="saknas">–</span>';
          tr.appendChild(td);
        });
        tbody.appendChild(tr);
      });
      t.appendChild(tbody); tableEl.innerHTML = ''; tableEl.appendChild(t);
    });
  }

  function init() { syncToggles(); renderBar(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { syncToggles(); renderBar(); });
})();
